import {
  Component,
  Input,
  ViewEncapsulation,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { PickService, ReportOrdersTotal, isEmptyObject } from "../../../core";
import { ReportPickingService } from "../../../report/report-picking/report-picking.service";
import { BehaviorSubject } from "rxjs";
import { SnackbarService } from "../../../shared";

enum ProductivityType {
  TOTAL = "Total",
  AMOUNT = "Amount",
  PERCENTAGE = "Percentage",
}

enum ProductivityTimeType {
  ATTEND_IN_RANGE = "Aten. en rango",
  NOT_ATTEND_IN_RANGE = "No aten. en rango",
  PERCENTAGE = "Porcentaje",
  TOTAL = "Total < x <",
  CERO_TWELVE = "0 - 12",
  TWELVE_TWENTY_FOUR = "12 - 24",
  TWENTY_FOUR_THIRTY = "24 - 30",
  HEIGHER_THIRTY = ">30",
  TOTAL_X_TD = "Total x TD",
  IN_RANGE = "En rango",
  DATE = "Date",
  TIME = "Time",
  IN_TOTAL = "Total",
}

@Component({
  standalone: false,
  selector: "app-picking-productivity-table",
  templateUrl: "./picking-productivity-table.component.html",
  styleUrls: ["./picking-productivity-table.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PickingProductivityTableComponent implements OnChanges {
  /**
   * Columns  of picking productivity table component
   */
  columns: string[] = [];
  /**
   * Type  of picking productivity table component
   */
  type = ProductivityType;
  /**
   * Input  of picking productivity table component
   */
  @Input() data: any[] = [];
  /**
   * Input  of picking productivity table component
   */
  @Input() sticky = false;
  /**
   * Input  of picking productivity table component
   */
  @Input() searchFilter = new BehaviorSubject(undefined);
  @Input() hasDetail = false;
  /**
   * Creates an instance of picking productivity table component.
   * @param pickService PickService
   * @param reportPickingService ReportPickingService
   * @param snackbarService SnackbarService
   */
  constructor(
    private pickService: PickService,
    private reportPickingService: ReportPickingService,
    private snackbarService: SnackbarService
  ) {}
  /**
   * on changes
   * @param changes SimpleChanges
   */
  ngOnChanges(changes: SimpleChanges): void {
    this.setColumns();
  }
  /**
   * Determines whether click export on
   * @param item_x any
   * @param item_y any
   */
  onClickExport(item_x: any, item_y: any) {
    let entityConcat = "";
    if (item_y.description === ProductivityTimeType.TOTAL) {
      const entities = item_x.detail
        .filter(
          (x) =>
            x.description != ProductivityTimeType.TOTAL &&
            x.description != ProductivityTimeType.PERCENTAGE
        )
        .map((x) => x.description);
      entityConcat = entities.join("|");
    } else {
      entityConcat = item_y.description;
    }
    const params: any = {};
    params.dateRange = this.getDateRangeByType(item_x.type, item_x);
    params.leadTimeRange = this.getLeadTimeRange(item_x.description);
    params.entity = entityConcat;
    this.showOrdersXLS(params);
  }
  /**
   * Gets condition export by type
   * @param item_x any
   * @param item_y any
   * @returns
   */
  getConditionExportByType(item_x: any, item_y: any) {
    const value = Number(item_y.value);
    if (value > 0) {
      /**
       * column total < x <
       */
      switch (item_y.description) {
        case ProductivityTimeType.TOTAL:
          return this.validationProductivityTimeType(item_x, item_y);
      }
      /**
       * enable export by description
       */
      if (item_y.type === ProductivityType.AMOUNT) {
        return this.validationProductivityTimeType(item_x, item_y);
      }
      /**
       * enable export by type
       */
      switch (item_x.type) {
        case ProductivityTimeType.DATE:
          return item_y.type === ProductivityType.AMOUNT ? true : false;

        default:
          break;
      }
    }
    return false;
  }
  /**
   * Validations productivity time type
   * @param item_x any
   * @param item_y any
   * @returns boolean
   */
  private validationProductivityTimeType(item_x: any, item_y: any): boolean {
    switch (item_x.description) {
      case ProductivityTimeType.CERO_TWELVE:
      case ProductivityTimeType.TWELVE_TWENTY_FOUR:
      case ProductivityTimeType.TWENTY_FOUR_THIRTY:
      case ProductivityTimeType.HEIGHER_THIRTY:
      case ProductivityTimeType.TOTAL_X_TD:
        return true;

      default:
        return false;
    }
  }
  /**
   * Shows orders xls
   */
  private showOrdersXLS(params) {
    this.pickService
      .getReportOrdersXls(isEmptyObject(params))
      .subscribe((res: ReportOrdersTotal[]) => {
        if (res && res.length > 0) {
          this.reportPickingService.exportOrdersPicking(res);
        } else {
          this.snackbarService.show("optionWithoutData", "error");
        }
      });
  }
  /**
   * Gets lead time range
   * @param description string
   * @returns string
   */
  private getLeadTimeRange(description: string) {
    switch (description) {
      case ProductivityTimeType.CERO_TWELVE:
        return "0:12";
      case ProductivityTimeType.TWELVE_TWENTY_FOUR:
        return "12:24";
      case ProductivityTimeType.TWENTY_FOUR_THIRTY:
        return "24:30";
      case ProductivityTimeType.HEIGHER_THIRTY:
        return "30:*";
      default:
        return "0:*";
    }
  }
  /**
   * Gets date range by type
   * @param type ProductivityTimeType
   * @param item_x any
   * @returns
   */
  private getDateRangeByType(type: ProductivityTimeType, item_x: any) {
    const values = this.searchFilter.value;
    if (item_x.sectionDate) {
      return `${item_x.sectionDate}:${item_x.sectionDate}`;
    }
    // switch (type) {
    //   case ProductivityTimeType.TIME:
    //   case ProductivityTimeType.DATE:
    //     if (this.hasDetail === true) {
    //       return `${item_x.description}:${item_x.description}`;
    //     }
    //     return `${item_x.description}:${item_x.description}`;

    //   default:
    //     return `${values.dateInitial}:${values.dateFinal}`;
    // }
    return `${values.dateInitial}:${values.dateFinal}`;
  }
  /**
   * Sets columns
   */
  private setColumns() {
    if (this.data && this.data.length > 0) {
      this.columns = this.data
        .map((x) => x.detail.map((z) => z.description))
        .find((x) => x);
      this.columns = ["Tiempo/Tiendas", ...this.columns];
    }
  }
}
